// CommonCheckbox.js
import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import PropTypes from 'prop-types';

const CCheckbox = ({ label, checked, onChange, ...props }) => {
  return (
    <FormControlLabel
      className="CCheckbox"
      control={
        <Checkbox
          disableRipple
          checked={checked}
          onChange={onChange}
          {...props}
        />
      }
      label={label}
    />
  );
};
CCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CCheckbox;
